import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-delete-assets-modal',
  imports: [BaseModalComponent, MatIconModule, MatProgressSpinnerModule, TranslocoDirective],
  templateUrl: './delete-assets-modal.component.html',
  styleUrl: './delete-assets-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteAssetsModalComponent {
  readonly borrowerName = input<string>('');

  readonly confirm = output<void>();

  readonly cancel = output<void>();

  protected readonly isLoading = signal(false);

  protected onConfirm(): void {
    this.isLoading.set(true);
    this.confirm.emit();
  }

  protected onCancel(): void {
    this.cancel.emit();
  }

  setLoading(loading: boolean): void {
    this.isLoading.set(loading);
  }
}
